module.exports = __webpack_public_path__ + "img/stock1.cc807a38.png";